import React from 'react'
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import gsap from 'gsap'
import { useGSAP } from '@gsap/react'

import './styles/cat.css'


const Cat = () => {

  const navigate = useNavigate()

  gsap.registerPlugin(useGSAP)

  const isMobile = window.innerWidth <= 768
  const isTablet = window.innerWidth > 768 && window.innerWidth <= 1440
  const isLarge = window.innerWidth > 1750

  const catRef = useRef(null)

  useGSAP(() => {
    if ( isMobile ) {
      gsap.fromTo(catRef.current,
        { x: '+300', y: '+300' }, {
          x: '60vw', y: '40vh',
          scale: 3,
          duration: 1,
          ease: 'easeInOut',
        })
    } else if ( isTablet ) {
      gsap.fromTo(catRef.current,
        { x: '+300', y: '+300' }, {
          x: '60vw', y: '40vh',
          scale: 2,
          duration: 1,
          ease: 'easeInOut',
        })
    } else if ( isLarge ) {
      gsap.fromTo(catRef.current,
        { x: '+300', y: '+300' }, {
          x: '65vw', y: '40vh',
          scale: 1,
          duration: 1,
          ease: 'easeInOut',
        })
    } else {
      gsap.fromTo(catRef.current,
        { x: '+300', y: '+300' }, {
          x: '75vw', y: '50vh',
          scale: 1,
          duration: 1,
          ease: 'easeInOut',
        })
    }

    gsap.to('.eyes', {
      y: '-20',
      x: '+5',
      duration: 0.5,
      delay: 0.75,
      stagger: 0.05,
      ease: 'easeIn'
    })
  })

  useEffect(() => {
    const pupilLeft = document.getElementById('left-eye')
    const pupilRight = document.getElementById('right-eye')

    const eyeLeft = { x: 112.795, y: 270.494 } // cx="112.795" cy="270.494"
    const eyeRight = { x: 264.795, y: 270.494} // cx="264.795" cy="270.494"
    const maxOffset = 10

    const handleMouseMove = (e) => {
      const { clientX, clientY } = e
      const { innerWidth, innerHeight } = window

      const offsetX = (clientX / innerWidth - 0.5) * 2
      const offsetY = (clientY / innerHeight - 0.5) * 2

      const pupilLeftX = eyeLeft.x + offsetX * maxOffset
      const pupilLeftY = eyeLeft.y + offsetY * maxOffset
      const pupilRightX = eyeRight.x + offsetX * maxOffset
      const pupilRightY = eyeRight.y + offsetY * maxOffset

      gsap.to(pupilLeft, { duration: 0.2, attr: { cx: pupilLeftX, cy: pupilLeftY } })
      gsap.to(pupilRight, { duration: 0.2, attr: { cx: pupilRightX, cy: pupilRightY } })
    }

    window.addEventListener('mousemove', handleMouseMove)

    // Cleanup on unmount
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [])

  return (
    <svg className="cat" viewBox="0 0 1750 800">
      <defs>
        <linearGradient id="cat-bg-gradient" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FF4500" />
          <stop offset="25%" stopColor="#9E0086" />
          <stop offset="50%" stopColor="#130065" />
        </linearGradient>
        <filter id="shadow" width="110%" height="104.4%" x="-2.5%" y="-2.7%" filterUnits="objectBoundingBox">
          <feOffset dx="10" dy="-5" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="5" />
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.544061407 0" />
        </filter>
      </defs>
      <g ref={catRef}
        fill="none" fillRule="evenodd"
        transform="rotate(-30 422.73 56.68)"
        onClick={() => navigate('/posts')}>
        <path fill="#111" filter="url(#shadow)" d="m0 0 125 125h150L400 0v1442H0z" />
        <path fill="#111" fillRule="evenodd" d="m0 0 125 125h150L400 0v1442H0z" />
        <path id="cat-bg" fill="url(#cat-bg-gradient)" d="m0 0 125 125h150L400 0v1442H0z" />
        <circle cx="124.795" cy="250.494" r="50" fill="#FFF" />
        <circle cx="274.795" cy="250.494" r="50" fill="#FFF" />
        <path fill="#FFF" d="m235.15 357.494-35.355 35.355-35.356-35.355z" />
        <circle id="left-eye" className="eyes" cx="112.795" cy="270.494" r="20" fill="#111" />
        <circle id="right-eye" className="eyes" cx="264.795" cy="270.494" r="20" fill="#111" />
      </g>
    </svg>
  )
}

export default Cat
